import { SVGProps } from "react";

const IconVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 17.25C1.08579 17.25 0.750003 16.9142 0.750001 16.5L0.75 11.25C0.749999 10.8358 1.08578 10.5 1.5 10.5C1.91421 10.5 2.25 10.8358 2.25 11.25L2.25 14.6893L8.46967 8.46963C8.76256 8.17673 9.23743 8.17673 9.53033 8.46962C9.82322 8.76252 9.82322 9.23739 9.53033 9.53028L3.31066 15.75L6.75 15.75C7.16421 15.75 7.5 16.0858 7.5 16.5C7.5 16.9142 7.16422 17.25 6.75 17.25L1.5 17.25Z"
      fill={"currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 0.75C16.9142 0.749999 17.25 1.08578 17.25 1.5V6.75C17.25 7.16421 16.9142 7.5 16.5 7.5C16.0858 7.5 15.75 7.16422 15.75 6.75L15.75 3.31066L9.53033 9.53028C9.23744 9.82318 8.76254 9.82327 8.46965 9.53038C8.17676 9.23748 8.17678 8.76252 8.46967 8.46963L14.6893 2.25001H11.25C10.8358 2.25001 10.5 1.91422 10.5 1.50001C10.5 1.08579 10.8358 0.750007 11.25 0.750005L16.5 0.75Z"
      fill="currentColor"
    />
  </svg>
);

export default IconVector;
